export default "__VITE_ASSET__9e61b99f__"